import React, { useState, useEffect } from "react";
import "./CandidateFilter.css";

export default function CandidateFilter({
  open,
  onClose,
  onApply,
  onClear,
  clientOptions = [],
  subVendorOptions = [],
  genderOptions = [],
  jobRoleOptions = [],
  candidateStatusOptions = [],
  qualificationOptions = [],
  sortOptions = [],
  initialValues,
}) {

  const [form, setForm] = useState({
    client: "",
    subVendor: "",
    gender: "",
    jobRole: "",
    candidateStatus: "",
    qualification: "",
    sortBy: "",
  });

  // ✅ Only ONE handleChange
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (open && initialValues) {
      setForm((prev) => ({ ...prev, ...initialValues }));
    }
  }, [open, initialValues]);

  if (!open) return null;

  const stop = (e) => e.stopPropagation();

  const handleClear = () => {
    const cleared = {
      client: "",
      subVendor: "",
      gender: "",
      jobRole: "",
      candidateStatus: "",
      qualification: "",
      sortBy: "",
    };

    setForm(cleared);
    onClear && onClear();
    onClose && onClose();
  };

  const handleApply = () => {
    onApply && onApply(form);
    onClose && onClose();
  };

  const renderOptions = (opts) => (
    <>
      <option value="">Select</option>
      {opts.map((o) => (
        <option key={o.value ?? o.label} value={o.value ?? o.label}>
          {o.label ?? o.value}
        </option>
      ))}
    </>
  );

  return (
    <div className="cand-filter-overlay" onClick={onClose}>
      <div className="cand-filter-modal" onClick={stop}>
        <div className="cand-filter-header">Filter</div>

        <div className="cand-filter-body">

          <label className="cand-filter-label">Client Name</label>
          <select name="client" className="cand-filter-select" value={form.client} onChange={handleChange}>
            {renderOptions(clientOptions)}
          </select>

          <label className="cand-filter-label">Sub Vendor</label>
          <select name="subVendor" className="cand-filter-select" value={form.subVendor} onChange={handleChange}>
            {renderOptions(subVendorOptions)}
          </select>

          <label className="cand-filter-label">Gender</label>
<select
  name="gender"
  className="cand-filter-select"
  value={form.gender}
  onChange={handleChange}
>
  <option value="">Select Gender</option>
  <option value="Male">Male</option>
  <option value="Female">Female</option>
  <option value="Other">Other</option>
</select>

          <label className="cand-filter-label">Job Role</label>
          <select name="jobRole" className="cand-filter-select" value={form.jobRole} onChange={handleChange}>
            {renderOptions(jobRoleOptions)}
          </select>

         <label className="cand-filter-label">Candidate Status</label>
<select
  name="candidateStatus"
  className="cand-filter-select"
  value={form.candidateStatus}
  onChange={handleChange}
>
  <option value="">Select Status</option>
  <option value="INITIAL">INITIAL</option>
  <option value="INTERVIEWED">INTERVIEWED</option>
  <option value="ACCEPTED">ACCEPTED</option>
  <option value="REJECTED">REJECTED</option>
  <option value="ONBOARDED">ONBOARDED</option>
</select>

          <label className="cand-filter-label">Qualification</label>
          <select name="qualification" className="cand-filter-select" value={form.qualification} onChange={handleChange}>
            {renderOptions(qualificationOptions)}
          </select>

          <label className="cand-filter-label">Sort By</label>
          <select name="sortBy" className="cand-filter-select" value={form.sortBy} onChange={handleChange}>
            {renderOptions(sortOptions)}
          </select>

        </div>

        <div className="cand-filter-actions">
          <button className="cand-btn cand-btn-clear" onClick={handleClear}>
            Clear
          </button>
          <button className="cand-btn cand-btn-apply" onClick={handleApply}>
            Apply
          </button>
        </div>

      </div>
    </div>
  );
}